var _rect, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntersect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#9b59b6",
    width: 300,
    height: 300
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 120,
    r: 50,
    fill: "#8e44ad"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    textAnchor: "middle",
    x: 150,
    y: 220
  }, "Profile")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/intersect.4d3cddb1cf7a58d2f769390fead3fa3f.svg";
export { ForwardRef as ReactComponent };